<template>
  <div>
    <div class="container col-lg-8 col-sm-12 mb-10 notifications">
      <h2 class="pb-2 text-center">Notifications</h2>
      <div v-if="isLoadingWorkers || isEditingDetails">
        <v-skeleton-loader type="list-item" v-for="i in 10" :key="i" />
      </div>
      <NotificationSettings
        @editNotification="editNotification"
        v-else-if="
          !isLoadingWorkers && has(userSettings, 'notifications.emails')
        "
        :initialNotifications="userSettings.notifications.emails"
      />
      <BaseFooter>
        <Permissioned
          section="settings"
          :vertical="isMobile"
          class="actions-bar"
        >
          <PrimaryButton
            @click.native="handleSave"
            :loading="isEditingDetails"
            permission="edit-notifications"
            :fullWidth="isMobile"
          >
            Save Changes
          </PrimaryButton>
        </Permissioned>
      </BaseFooter>
    </div>
  </div>
</template>

<script>
import NotificationSettings from "@/views/settings/components/NotificationSettings";
import BaseFooter from "@/components/common/BaseFooter";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { has, findIndex } from "lodash";
import Permissioned from "@/components/common/Permissioned";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import {
  FETCH_USER_SETTINGS,
  EDIT_USER_SETTINGS
} from "@/store/modules/users/actions";
import { USERS_NAMESPACE } from "@/store/modules/users";
import {
  GET_IS_FETCHING_USER_SETTINGS,
  GET_USER_SETTINGS
} from "@/store/modules/users/getters";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

const {
  mapActions: mapUsersActions,
  mapGetters: mapUsersGetters
} = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  name: "Profile",
  components: {
    PrimaryButton,
    BaseFooter,
    NotificationSettings,
    Permissioned
  },
  created() {
    this.fetchUserSettings();
  },
  data() {
    return {
      editedNotifications: [],
      isEditingDetails: false,
      showValidationErrors: false
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    ...mapUsersGetters({
      userSettings: GET_USER_SETTINGS,
      isLoadingWorkers: GET_IS_FETCHING_USER_SETTINGS
    })
  },
  methods: {
    ...mapUsersActions({
      fetchUserSettings: FETCH_USER_SETTINGS,
      editUserSettings: EDIT_USER_SETTINGS
    }),
    async handleSave() {
      this.showValidationErrors = true;
      this.isEditingDetails = true;
      if (this.editedNotifications.length) {
        await this.editUserSettings(this.editedNotifications);
      }
      this.editedNotifications = [];
      this.isEditingDetails = false;
      this.showValidationErrors = false;
    },
    editNotification(notification) {
      const notificationIndex = findIndex(this.editedNotifications, {
        key: notification.key
      });
      if (notificationIndex > -1) {
        this.editedNotifications[notificationIndex] = notification;
      } else {
        this.editedNotifications = [...this.editedNotifications, notification];
      }
    },
    has
  }
};
</script>

<style lang="scss">
.notifications {
  padding-bottom: 100px;
}
</style>
